import { EColorVariablesV2 } from '@/types/theme-packs.types';

const getThemeColorContrastCSSVariable = (foreground: EColorVariablesV2, background: EColorVariablesV2) => {
  return `var(--project-theme-color-contrast-${foreground}-over-${background})`;
};

export default getThemeColorContrastCSSVariable;
